import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_CHARGE_SPEED = createActionTypes('FETCH_CHARGE_SPEED');
export const GET_CHARGE_SPEED = createActionTypes('GET_CHARGE_SPEED');
export const CREATE_CHARGE_SPEED = createActionTypes('CREATE_CHARGE_SPEED');
export const UPDATE_CHARGE_SPEED = createActionTypes('UPDATE_CHARGE_SPEED');
export const DELETE_CHARGE_SPEED = createActionTypes('DELETE_CHARGE_SPEED');
